import React from "react";
import Rx from "rx";
import "../../assets/styles/pin.css";
import lock from "../../assets/images/lock_black_24dp.svg";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";
export default class Pin extends React.Component {
  componentDidMount() {
    this.props.setFocus("breadcrumbs.stage");
    sendDataLayer(gtmConstant.SecretCode.FUNNEL_STEP, {
      process_type: gtmConstant.SecretCode.PROCESS_NAME,
      step_title: gtmConstant.SecretCode.STEP_TITLE.DISPLAY_CODE,
      step_number:2,
      error_type:gtmConstant.SecretCode.NA
    });
    this.props.setFocus("breadcrumbs.stage");
    const timeout = this.props.timeout;
    const speed = timeout * 10 + 1;
    const sec = Rx.Observable.interval(100).take(speed);
    const onLogout = this.props.onLogout;
    const onTimerEnded = this.props.onTimerEnded;
    const startime = Date.now();

    this.timerlogout = sec.subscribe((x) => {
      let elapsedMs = Date.now() - startime; //re-calc x by matching it to the elapsed milliseconds pasted from the start of the count
      let now = parseInt(elapsedMs / 100);

      let percent = String(100 - (now / timeout) * 10);
      let time = timeout * 10 - now;

      this.props.onTimerChange(percent, time);
      if (time <= 0) {
        onTimerEnded();
        onLogout();
      }
    });
  }

  componentWillUnmount() {
    this.timerlogout.dispose();
  }

  handleButtonClick = (redirectTarget, buttonText) => {
    // שליחת אירוע ל-GTM
    sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
      process_type: gtmConstant.SecretCode.PROCESS_NAME,
      step_title: gtmConstant.SecretCode.STEP_TITLE.DISPLAY_CODE,
      step_number: 2,
      click_text: buttonText,
    });
  
    // הפנייה ליעד הרצוי
    this.props.redirect(redirectTarget);
  };

  render() {
    let pinWrapper = "";

    if (this.props.provider === "default") {
      pinWrapper = "cal pin-wrapper bg-t";
    } else {
      pinWrapper = "pin-wrapper bg-t";
    }
    const digits = {
      d1: "אחת",
      d2: "שתיים",
      d3: "שלוש",
      d4: "ארבע",
      d5: "חמש",
      d6: "שש",
      d7: "שבע",
      d8: "שמונה",
      d9: "תשע",
      d0: "אפס",
    };

    let { timeout } = this.props;

    const stringifyNum = (pin) => {
      let dig = "";
      for (var i = 0; i < pin.length; i++) {
        dig += digits["d" + pin[i]] + " ";
      }

      return dig;
    };

    const beautifyTime = (time, isSr, shouldDelay) => {
      let seconds = parseInt(((time + 10) / 10) % 60);
      let minutes = parseInt((time + 10) / 10 / 60);

      if (isSr && shouldDelay) {
        seconds = (parseInt(seconds / 10) + 1) * 10;
        if (seconds % 60 == 0) {
          minutes += 1;
          seconds = 0;
        }
      }

      let fixedSeconds = seconds < 10 ? "0" + seconds : seconds.toString();
      let fixedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

      if (isSr) {
        if (shouldDelay && timeout - 30 > time / 10 + 1) {
          return "נותרו 00:" + fixedMinutes + ":" + fixedSeconds;
        }
        if (!shouldDelay) return "00:" + fixedMinutes + ":" + fixedSeconds;

        return "";
      } else {
        return fixedMinutes + ":" + fixedSeconds;
      }
    };

    return (
      <div className={pinWrapper}>
        <div>
          <h3 className="pin-title f2">
            <span className="sr-only">שחזור קוד סודי - </span>
            <div>
              <span>הקוד הסודי של</span>
              <span>הכרטיס הוא</span>
            </div>
          </h3>
        </div>
        <div className="code-number-warp">
          <div className="code-number-container">
            <div className="code-number">
              <div>{this.props.pin}</div>
            </div>
            <div className="code-number-timer">
              <div
                className="second-line"
                style={{ width: `${this.props.percent}%` }}
              />
            </div>
          </div>
          <div className="time-msg">הקוד יוצג למשך שתי דקות</div>
        </div>

        <span className="sr-only">
          הזמן שנותר להצגת הקוד הוא: {beautifyTime(this.props.time, true)}
        </span>
        <div>
          {this.props.cards.length > 1 && (
            <button
              className="btn change-card pointer"
              aria-label="לחץ להחלפת כרטיס"
              type="button"
              onClick={() => this.handleButtonClick("cards", "לצפייה בקוד של כרטיס אחר")}
            >
              לצפייה בקוד של כרטיס אחר
            </button>
          )}
          <button
            aria-label="סגור הצגת כרטיס סודי"
            type="button"
            className="btn bg-m color-n color-nl f6 thanks pointer"
            onClick={() => this.handleButtonClick("thankYou", "קיבלתי, תודה")}
          >
            קיבלתי, תודה
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/Pin.jsx